// Paid-plan detection shared by the Real Mode gateway and Studio.
// Live /billing/me is { profile, tier: { label, allow_real_uploads }, tier_key, mocked }.
// tier_key "free" is a truthy string, so it must not hide profile.plan or tier.label.

const SOLD_PLANS = new Set(["starter", "founding_beta", "payg", "professional", "firm"]);

export function normalizePlan(value) {
    const text = String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
    if (!text || text === "free" || text.startsWith("free tier")) return null;
    if (text === "founding_beta" || text.startsWith("founding beta")) return "founding_beta";
    if (text === "starter" || text.startsWith("starter")) return "starter";
    if (text === "payg" || text.startsWith("pay-as-you-go") || text.startsWith("pay as you go")) return "payg";
    if (text.startsWith("professional")) return "professional";
    if (text.startsWith("firm")) return "firm";
    return SOLD_PLANS.has(text) ? text : null;
}

export function planFromBillingMe(data) {
    if (!data || typeof data !== "object") return null;
    const profile = data.profile && typeof data.profile === "object" ? data.profile : null;
    const tier = data.tier && typeof data.tier === "object" ? data.tier : null;
    const stripeLinked = Boolean(
        profile
        && (
            String(profile.sru_grant_source || "").toLowerCase() === "stripe"
            || profile.stripe_subscription_id
            || profile.stripe_customer_id
        ),
    );
    return normalizePlan(data.tier_key)
        || normalizePlan(profile && profile.plan)
        || normalizePlan(tier && tier.label)
        || normalizePlan(data.tier_label)
        || normalizePlan(data.plan)
        || (stripeLinked && Number(profile.sru_purchased) > 0 ? "founding_beta" : null);
}

export function planFromBalance(data) {
    if (!data || typeof data !== "object") return null;
    return normalizePlan(data.tier_label) || normalizePlan(data.tier_key) || normalizePlan(data.plan);
}

export function accountIsPaid(meData, balanceData) {
    if (planFromBillingMe(meData) || planFromBalance(balanceData)) return true;
    const tier = meData && typeof meData.tier === "object" ? meData.tier : null;
    return Boolean(tier && tier.allow_real_uploads === true);
}
